import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_024.jpg';
page.paint = [
  {
    id: 'page012_game1',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Połącz kolejne kropki za pomocą narzędzia <i>Pędzel</i> <br/>i dokończ rysunki.  ',
      audio: 'files/page012/z12c2.mp3',
      item: {
        path: 'informatyka/files/page012/z.12cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page012_game2',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Otocz zbiory pętlami za pomocą narzędzia <i>Pędzel</i>.  ',
      audio: 'files/page012/z12c3.mp3',
      item: {
        path: 'informatyka/files/page012/z.12cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.images = [
  {
    imageId: 'page024_zoom0',
    rectangle: {
      x: 613,
      y: 1572,
      width: 1166,
      height: 888,
    },
    imageSrc: 'images/page024/024 1.jpg',
  },
  {
    imageId: 'page024_zoom1',
    rectangle: {
      x: 134,
      y: 343,
      width: 1624,
      height: 844,
    },
    imageSrc: 'images/page024/024 2.jpg',
  },
];
page.games = [
  {
    id: 'page012_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  {
    id: 'page012_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  {
    id: 'page024_game10',
    icon: 'ikonaStepbystep',

    pos: {
      x: LEFT,
      y: 1524,
    },
    item: {
      id: 'page024_game10',
    },
    rectangle: {
      id: 'page024_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page024_rect0',

    tooltip: '',

    linked: ['page024_game10'],
    x: 120,
    y: 1524,
    width: 465,
    height: 974,
  },
];
export default page;
